import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { DirectionProvider } from "@radix-ui/react-direction";

import App from "./App";
import { queryClient } from "@/lib/query";
import "./index.css";

// Wrap the entire app in Radix's DirectionProvider so every primitive
// (DropdownMenu, Dialog, Select, Tooltip, Popover, ...) inherits dir="rtl"
// instead of the Radix default ("ltr"). Without this, the dropdown content
// portal renders LTR even though our <html> is RTL, causing the menu to
// flip to the wrong side and the chevron/inset paddings to land backwards.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <DirectionProvider dir="rtl">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
          <Toaster
            position="bottom-left"
            dir="rtl"
            richColors
            closeButton
            theme="dark"
            toastOptions={{
              classNames: { toast: "font-sans" },
            }}
          />
        </BrowserRouter>
      </QueryClientProvider>
    </DirectionProvider>
  </React.StrictMode>
);
